<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
  >
    <g fill="#13A2E8" fill-rule="evenodd">
      <path
        d="M4.667 2.667H10V1.333H4.667v1.334zM4 4c-.428 0-.668-.238-.668-.667V.667c0-.43.24-.667.668-.667h6.666c.428 0 .666.236.666.667v2.666c0 .429-.238.667-.666.667H4z"
        transform="translate(.667 .667)"
      />
      <path
        d="M1.333 7.333h12V4h-12v3.333zM14 2.667c.428 0 .667.236.667.666V8c0 .43-.397.667-.826.667H8.667V7.333H6v1.334H.778C.348 8.667 0 8.43 0 8V3.333c0-.43.236-.666.667-.666H14z"
        transform="translate(.667 .667)"
      />
      <path
        d="M2 12.684h10.667V8.667H2v4.017zm4-4.017h2.667V7.333h4.666c.43 0 .667.307.667.738v5.262c0 .43-.236.667-.667.667h-12c-.43 0-.666-.236-.666-.667V8.071c0-.43.236-.738.666-.738H6v1.334z"
        transform="translate(.667 .667)"
      />
      <path
        d="M9.333 6c.429 0 .667.236.667.667v2.666c0 .429-.238.667-.667.667h-4c-.43 0-.666-.238-.666-.667V6.667c0-.43.236-.667.666-.667h4zm-.666 1.333H6v1.334h2.667V7.333z"
        transform="translate(.667 .667)"
      />
    </g>
  </svg>
</template>